import { render } from "./ContainerInfo.vue?vue&type=template&id=011e2a71"
import script from "./ContainerInfo.vue?vue&type=script&lang=js"
export * from "./ContainerInfo.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/container.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fagro_exporter%2Ffinances%2Fcontainer_incomes%2FContainerInfo.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__